import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { ImageGridView } from './ImageGridView';

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        imageGrid: {
            insertImageGrid: () => ReturnType;
        };
    }
}

export const ImageGridCell = Node.create({
    name: 'imageGridCell',
    group: 'imageGridCell',
    atom: true,
    selectable: false,
    addAttributes() {
        return {
            src: { default: null },
            fileId: { default: null },
            caption: { default: '' }
        };
    },
    parseHTML() {
        return [{ tag: 'div[data-image-grid-cell]' }];
    },
    renderHTML({ HTMLAttributes }) {
        return ['div', mergeAttributes({ 'data-image-grid-cell': '' }, HTMLAttributes)];
    }
});

export const ImageGrid = Node.create({
    name: 'imageGrid',
    group: 'block',
    content: 'imageGridCell+',
    isolating: true,
    draggable: true,
    addAttributes() {
        return {
            rows: { default: 1 },
            cols: { default: 1 },
            rowHeight: { default: 140 },
            colWidths: { default: [100] }
        };
    },
    parseHTML() {
        return [{ tag: 'div[data-image-grid]' }];
    },
    renderHTML({ HTMLAttributes }) {
        return ['div', mergeAttributes({ 'data-image-grid': '' }, HTMLAttributes), 0];
    },
    addNodeView() {
        return ReactNodeViewRenderer(ImageGridView);
    },
    addCommands() {
        return {
            insertImageGrid:
                () =>
                ({ chain }) => {
                    const cells = [
                        { type: 'imageGridCell', attrs: { src: null, fileId: null, caption: '' } }
                    ];
                    return chain()
                        .focus()
                        .insertContent({
                            type: 'imageGrid',
                            attrs: { rows: 1, cols: 1, rowHeight: 140, colWidths: [100] },
                            content: cells
                        })
                        .run();
                }
        };
    }
});
